import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaUser, FaComment } from 'react-icons/fa';
import '../components/Contact/Contact.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <div className="contact-section section-padding" style={{ marginTop: '80px' }}>
      <div className="contact-container">
        <div className="section-title">
          <div className="section-subtitle">Get In Touch</div>
          <h2>Contact Redfox Digital</h2>
          <p>Ready to transform your business? Let's discuss your project and bring your vision to life.</p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3>Let's Start a Conversation</h3>
            <p>We're here to help you grow your business with cutting-edge digital solutions. Reach out to us for expert consultation.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-text">
                  <h4>Our Location</h4>
                  <p>Bhubaneswar, Odisha, India</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <div className="contact-text">
                  <h4>Phone Numbers</h4>
                  <p>+91 7438037542</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div className="contact-text">
                  <h4>Email Address</h4>
                  <p>redfoxdotin@gmail.com</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <FaClock />
                </div>
                <div className="contact-text">
                  <h4>Working Hours</h4>
                  <p>Mon - Sat: 10:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>

            <div className="business-hours">
              <h4>Business Hours</h4>
              <ul className="hours-list">
                <li><span>Monday - Friday</span><span>10:00 AM - 6:00 PM</span></li>
                <li><span>Saturday</span><span>10:00 AM - 4:00 PM</span></li>
                <li><span>Sunday</span><span>Closed</span></li>
              </ul>
            </div>
          </div>

          {/*<div className="contact-form">
            <h3>Send Us a Message</h3>
            <p>Fill out the form below and we'll get back to you within 24 hours.</p>
            
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 9876543210"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a service</option>
                    <option value="web-development">Web Development</option>
                    <option value="ecommerce">E-commerce Solutions</option>
                    <option value="digital-marketing">Digital Marketing</option>
                    <option value="mobile-app">Mobile App Development</option>
                    <option value="consultation">Free Consultation</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about your project requirements..."
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          </div>*/}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;